<template>

  <div id="public-foot">
    <!-- 底部区域 -->
    <footer class="foots">

      <!-- <router-link to="/index2019" class="back fl">
                <div class="foot-btn" >返回榜单主页</div> -->
      <div class="foot-btn" @click="backtop">返回榜单主页</div>

      <!-- </router-link> -->
    </footer>
  </div>
</template>
<script>
export default {
  props: {
    topImgUrl: {
      // type: String,
      // required: true

    }
  },
  data() {
    return {
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    /**
             * 回到顶部功能实现过程：
             * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
             * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
             * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
             * 4. 最后记得在移动到顶部时，清除定时器
             */
    backtop() {
      // var timer = setInterval(function () {
      //     let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      //     let ispeed = Math.floor(-osTop / 5);
      //     document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
      //     this.isTop = true;
      //     if (osTop === 0) {
      //         clearInterval(timer);
      //     }
      // }, 30)
      // this.$router.back(-1)
      this.$router.push('/index2019')
    }

  }
}
</script>

<style scoped lang="scss">
    @import "../../style/scss/public.scss";

    #public-foot {
        .foots {
            height: rem(150);
            background: rgba(247, 247, 247, 1);
            text-align: center;
            line-height: rem(150);
            display: flex;
            flex-direction: column;
            align-items: center;
            /*由于flex-direction: column，因此align-items代表的是水平方向*/
            justify-content: center;

            .foot-btn {
                width: rem(228);
                height: rem(70);
                border: 2px solid rgba(174, 122, 69, 1);
                text-align: center;
                line-height: rem(70);
                font-size: rem(28);
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(174, 122, 69, 1);
                letter-spacing: 1px;
            }

        }
    }
</style>
